/* eslint-disable */
export default {
  unknown: 'Desconhecido',
  multipleMatches: 'Várias correspondências',
  anonymous: 'Anônimo',
  none: 'Nenhum',
} as const;

// @key: @#@"unknown"@#@ @source: @#@"Unknown"@#@
// @key: @#@"multipleMatches"@#@ @source: @#@"Multiple matches"@#@
// @key: @#@"anonymous"@#@ @source: @#@"Anonymous"@#@
// @key: @#@"none"@#@ @source: @#@"None"@#@
